import { ToastManager } from '../../ToastManager';

import { useI18n } from '../../hooks/useI18nFormatters';
import { useApp } from '../../store/apps/useApps.ts';
import { useApi } from '../../store/SelectedHomeyStore.hooks.ts';

import { glyph } from '../../theme/glyph';

import { ContextMenuContent } from '../../components/common/context-menu/ContextMenuContent';
import { DeveloperMenu } from '../../components/common/context-menu/DeveloperMenu';

import { AppSettingsDialogUninstall } from './apps/AppSettingsDialogUninstall';

export function SettingsNavigationItemAppContextMenuContent(props) {
  const { i18n } = useI18n();
  // const ctx = useContextMenuContext();

  const { api } = useApi();
  const { app } = useApp({ appId: props.appId });

  const isRestartDisabled = (() => {
    switch (true) {
      case app == null:
      case app.enabled !== true:
      case app.state === 'stopping':
      case app.state === 'starting':
        return true;
      case app.state === 'running':
      case app.state === 'crashed':
      case app.state === 'stopped':
        return false;
      default:
        return true;
    }
  })();

  function onAction(key) {
    switch (key) {
      case 'restart':
        api.apps
          .restartApp({ id: props.appId })
          .then(() => {})
          .catch(ToastManager.handleError)
          .finally(() => {});
        break;
      case 'uninstall':
        AppSettingsDialogUninstall.route.open({
          context: { appId: props.appId },
        });
        break;
      default:
        break;
    }
  }

  return (
    <ContextMenuContent.List>
      {api?.isCloud !== true && (
        <ContextMenuContent.ListItem
          label={i18n.messageFormatter('common.restart')}
          icon={glyph.core.arrowDoubleCircularRotated}
          isDisabled={isRestartDisabled}
          onPress={() => {
            onAction('restart');
          }}
        />
      )}

      <DeveloperMenu onIdRequest={() => app?.id} onResourceRequest={() => app} />

      <ContextMenuContent.Divider />
      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.uninstall')}
        variant="danger"
        icon={glyph.core.trashFill}
        onPress={() => {
          onAction('uninstall');
        }}
      />
    </ContextMenuContent.List>
  );
}
